import axios from "axios";
import { ShipDataType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";
import { getToken } from "@/utils/authHelpers";

export const editShipApi = async (
  shipId: string,
  updatedData: any,
): Promise<ShipDataType> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");
  try {
    const response = await axios.put<ShipDataType>(
      `${API_BASE_URL}/update-ship/${shipId}`,
      updatedData,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  } catch (error) {
    console.error("Error editing Ship", error);
    throw error;
  }
};
